"use client";
import withSubscribe from "@/hocs/withSubscribe";
import React from "react";
import SubscriptionButton from "../SubscribeButton/SubscribeButton";
import { GalleryI } from "@/interfaces/galleries/Galleries";

type sub = {
  gallery: GalleryI;
};
export const SubscriptionBtn = (props: sub) => {
  const { gallery } = props;
  const SubBtn = withSubscribe(SubscriptionButton);
  return <SubBtn gallery={gallery} />;
};
